import Card from '@trinsly/common/src/components/atoms/card'
import Column from '@trinsly/common/src/components/atoms/column'
import Form from '@trinsly/common/src/components/atoms/form'
import Heading from '@trinsly/common/src/components/atoms/heading'
import Separator from '@trinsly/common/src/components/atoms/separator'
import Text from '@trinsly/common/src/components/atoms/text'
import Button from '@trinsly/common/src/components/molecules/button'
import Modal from '@trinsly/common/src/components/molecules/modal'
import useForm from '@trinsly/common/src/hooks/use-form'
import required from '@trinsly/common/src/validations/required'
import useLinkCampaignToProject from 'api-hooks/use-link-campaign-to-project'
import MultiSelectCampaigns from 'components/multi-select-campaigns'
import React from 'react'
import { toast } from 'react-toastify'

import CampaignType from 'types/campaign-type'
import ProjectType from 'types/project-type'

type LinkCampaignsToProjectModalProps = {
  project: ProjectType | undefined
  visible: boolean
  onRequestClose: () => void
}

function LinkCampaignsToProjectModal({
  project,
  visible,
  onRequestClose,
}: LinkCampaignsToProjectModalProps) {
  const { fetch: addCampaignToProject, pending: pendingAddCampaignToProject } =
    useLinkCampaignToProject({
      onSuccess: () => {
        toast.success('Campaigns added to Project')
        onRequestClose?.()
      },
      onError: (error) => {
        toast.error('Error adding campaigns to project')
      },
    })

  const { getValue, setValue, getError, getValues, setValues, submit, reset } =
    useForm({
      onSubmit: ({ campaigns }: { campaigns: CampaignType[] }) => {
        addCampaignToProject({
          projectId: project?.id || -1,
          campaignIds: campaigns?.map((c) => c.id) || [],
        })
      },
      validations: {
        campaigns: [required],
      },
    })

  React.useEffect(() => {
    if (visible) {
      reset()
    }
  }, [visible])

  return (
    <Modal visible={visible} onRequestClose={onRequestClose}>
      <Card>
        <Form onSubmit={submit}>
          <Column className="p-md gap-lg">
            <Heading size="xl" fontWeight="bold">
              Add a Campaigns to {project?.name}
            </Heading>
            <Column>
              <Text size="xs" fontWeight="bold" className="uppercase">
                Campaigns
              </Text>
              <Separator size="xs" />
              <MultiSelectCampaigns
                placeholder="Select a campaigns"
                values={getValue('campaigns')}
                onChange={(value) => setValue('campaigns', value)}
                error={getError('campaigns')}
              />
            </Column>
          </Column>
          <Modal.Footer>
            <Button className="min-w-28" onClick={onRequestClose}>
              Cancel
            </Button>
            <Separator size="sm" />
            <Button
              type="submit"
              className="min-w-52"
              intent="primary"
              pending={pendingAddCampaignToProject}
            >
              Add Campaigns
            </Button>
          </Modal.Footer>
        </Form>
      </Card>
    </Modal>
  )
}

export default LinkCampaignsToProjectModal
